import { useEffect } from "react";

interface MetaTagsProps {
  title?: string;
  description?: string;
  image?: string;
  url?: string;
  type?: string;
}

export const MetaTags = ({
  title = "Ritual - Turn processes into rituals",
  description = "Ritual helps teams capture, automate, and enforce SOPs with proof-based completion. Swipe right to complete. Left to skip. That's it.",
  image = "https://ritual.app/og-image.png",
  url = "https://ritual.app",
  type = "website"
}: MetaTagsProps) => {
  useEffect(() => {
    // Update document title
    document.title = title;
    
    // Helper to update or create meta tag
    const setMetaTag = (property: string, content: string, isName = false) => {
      const attr = isName ? "name" : "property";
      let meta = document.querySelector(`meta[${attr}="${property}"]`);
      
      if (!meta) {
        meta = document.createElement("meta");
        meta.setAttribute(attr, property);
        document.head.appendChild(meta);
      }
      
      meta.setAttribute("content", content);
    };
    
    // Open Graph
    setMetaTag("og:title", title);
    setMetaTag("og:description", description);
    setMetaTag("og:image", image);
    setMetaTag("og:url", url);
    setMetaTag("og:type", type);
    setMetaTag("og:site_name", "Ritual");
    
    // Twitter Card
    setMetaTag("twitter:card", "summary_large_image", true);
    setMetaTag("twitter:title", title, true);
    setMetaTag("twitter:description", description, true);
    setMetaTag("twitter:image", image, true);
    setMetaTag("twitter:site", "@RitualOps", true);
    
    // Standard meta
    setMetaTag("description", description, true);
    
  }, [title, description, image, url, type]);
  
  return null;
};
